/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Light_Fair_Lion_PurrInputs */

const en_light_fair_lion_purr = /** @type {(inputs: Light_Fair_Lion_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset to default`)
};

const de_light_fair_lion_purr = /** @type {(inputs: Light_Fair_Lion_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Standard zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset to default" |
*
* @param {Light_Fair_Lion_PurrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const light_fair_lion_purr = /** @type {((inputs?: Light_Fair_Lion_PurrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Light_Fair_Lion_PurrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_light_fair_lion_purr(inputs)
	return de_light_fair_lion_purr(inputs)
});